module.exports = __webpack_public_path__ + "static/media/Security.b2d4520e.svg";